import Vue from "vue";
import axios from "axios";
import config from "@core/config/app.config.js";
import store from "@/store"
import {refreshToken, toReauth } from '@core/config/utils'

/**
 * Identity server instance
 */
const Repository = axios.create({
  baseURL: config.MAROPOST_IDENTITY_BASE_URL
});

/**
 * Intercept all requests sent to Identity
 */
Repository.interceptors.request.use(async config => {
    try {
      const keycloak = Vue.prototype.$keycloak;
      await refreshToken();
        const token = keycloak.token;
        if (token) config.headers["Authorization"] = 'Bearer ' + token;
    } catch ( err ){
        console.log(err)
    } finally {
        return config;
    }
});

Repository.interceptors.response.use(null, async error => {
    if (error.response || error.request) {
      const data = error.response || error.request;
      switch (data.status) {
        case 401:
          toReauth();
          break;
      }
    }
    return  Promise.reject(error)
  });

export default Repository;
